module.exports = __webpack_public_path__ + "static/media/bag-cleaning.ab0e72e9.webp";